import { professionalTranslationFor } from './professionalTranslationRuntime.js';

// The Standard and Large Text print layouts are two presentations of the
// same patient-facing document. This source excludes Studio-only controls.
// A professional review of these source strings does NOT approve a
// Trust-specific Journey to be issued in another language.
export const STANDARD_JOURNEY_PRINT_ENGLISH = Object.freeze({
  whatMayHappen: 'What may happen',
  whyItMayHappen: 'Why this may happen',
  whatTeamIsDoing: 'What your care team is doing',
  variationNote: 'This may vary',
  nextSteps: 'What may happen next',
  professionalClothes: 'Usually wears professional clothes rather than a standard uniform.',
  wearsColourGarment: 'Usually wears {colour} {garment}.',
  wearsGarment: 'Usually wears a {garment}.',
  genericGarment: 'clinical clothing',
  preparationChecklist: 'Preparation checklist',
  understandingReminder: 'This is an understanding check. Follow the instructions from your own hospital team.',
  whatYouMightHear: 'What you might hear',
  whatItMeans: 'What it means:',
  questionsToConsider: 'Questions you may wish to ask',
  peopleYouMayMeet: 'People you may meet',
  clothes: 'Clothes:',
  officialHospitalInformation: 'Official hospital information',
  localHospital: 'Local hospital',
  forLocalReview: 'For local hospital review',
  evaluationDraft: 'Evaluation draft',
  prepared: 'Prepared',
  coverReminder: 'This guide is for information and preparation. Follow the advice given by your own hospital team.',
  stage: 'Stage',
  of: 'of',
  yourCareTeam: 'Your care team',
  questionsAndNotes: 'Questions and notes',
  questionsToAskMyTeam: 'Questions to ask my team',
  writingPrompt: 'Write down anything you would like to ask your hospital team.',
  spaceForQuestions: 'Space to write questions',
  notesToRemember: 'Notes to remember',
  notesPrompt: 'Use this space for dates, instructions or other notes.',
  spaceForNotes: 'Space to write notes',
  importantInformation: 'Important information',
  pleaseRemember: 'Please remember',
  askForExplanation: 'If anything is unclear, ask your local hospital team to explain it.',
  footerAdvice: 'Check advice with your local hospital team.',
});

export function standardJourneyPrintCopy(language = 'en') {
  const code = String(language || 'en').toLowerCase().split('-')[0];
  return Object.fromEntries(Object.entries(STANDARD_JOURNEY_PRINT_ENGLISH).map(([key, english]) => [
    key, professionalTranslationFor(code, 'standardJourneyPrint', key) || english,
  ]));
}

export function formatStandardPrintText(template, values) {
  return String(template || '').replace(/\{([a-zA-Z]+)\}/g, (match, name) =>
    Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match);
}
